var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotWorking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 4.375L22.5 2.5L20.625 4.375L18.75 2.5L16.875 4.375L15 2.5L13.125 4.375L11.25 2.5L9.375 4.375L7.5 2.5V20H3.75V23.75C3.75 25.825 5.425 27.5 7.5 27.5H22.5C24.575 27.5 26.25 25.825 26.25 23.75V2.5L24.375 4.375ZM18.75 25H7.5C6.8125 25 6.25 24.4375 6.25 23.75V22.5H18.75V25ZM23.75 23.75C23.75 24.4375 23.1875 25 22.5 25C21.8125 25 21.25 24.4375 21.25 23.75V20H10V6.25H23.75V23.75Z",
    fill: "#E53E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.75H11.25V11.25H18.75V8.75Z",
    fill: "#E53E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.75H20V11.25H22.5V8.75Z",
    fill: "#E53E3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.5H11.25V15H18.75V12.5Z",
    fill: "#E53E3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.5H20V15H22.5V12.5Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotWorking);
export default __webpack_public_path__ + "static/media/Not Working.b766617c9c432fbdde0374c7a9aa2fed.svg";
export { ForwardRef as ReactComponent };